import {OfferSaleVehicleResponseBody} from '@dms/api/finance';
import {BusinessCaseResponseBody} from '@dms/api/sales';
import {SaleVehicleResponseBody} from '@dms/api/vehicle';

const OPEN_BUSINESS_CASE_STATES = [
  'CONCEPT',
  'OFFER',
  'CONTRACT',
  'DEPOSIT',
  'DEPOSIT_PAID',
] as const;

interface useBusinessCasePriceLogicProps {
  businessCaseData?: BusinessCaseResponseBody;
  saleVehicleData?: SaleVehicleResponseBody;
  saleVehicle: OfferSaleVehicleResponseBody;
  isBrokeredSale: string | null;
}

export function useBusinessCasePriceLogic(props: useBusinessCasePriceLogicProps) {
  const isBrokerage = props.saleVehicleData?.type === 'BROKERAGE';

  const isOpenBusinessCase = props.businessCaseData?.businessCaseState
    ? OPEN_BUSINESS_CASE_STATES.includes(props.businessCaseData.businessCaseState)
    : false;

  const totalMarginPercentage = Number(props.saleVehicle?.margin);

  const isTotalVatDeductible =
    props.saleVehicle?.priceTotalAfterDiscount?.withVat?.amount !==
      props.saleVehicle?.priceTotalAfterDiscount?.withoutVat?.amount ||
    (props.saleVehicle?.upsell?.length ?? 0) > 0;

  const shouldShowBrokerageContent = isBrokerage || Boolean(props.isBrokeredSale);

  return {
    isBrokerage,
    isOpenBusinessCase,
    totalMarginPercentage,
    isTotalVatDeductible,
    shouldShowBrokerageContent,
  };
}
